import { handleCommunicationLogsUpdate } from "@/helpers/websockets/communication/handlers";

export const COMMUNICATION_LOGS_EVENT = ".communication_logs" as const;

export const COMMUNICATION_LOGS_EVENT_HANDLERS = {
  [COMMUNICATION_LOGS_EVENT]: handleCommunicationLogsUpdate
};
